module.exports = __webpack_public_path__ + "static/media/icon_167.0b355796.svg";